module.exports = __webpack_public_path__ + "img/icon-share.43ab2de9.svg";